<template>
    <div
        class="animated fadeIn"
    >
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else-if="$helper.isBlank(currOffice)" class="division-container my-auto main-body"
        style="background-image: url('katalog-bg.png');">
            <div class="division-logo">
                <b-img class="division-logo-image" src="/logo.png" block alt="Sinar Mutiara Logo"></b-img>
            </div>
            <div class="division-date">
                <b-img class="division-date-image" src="/logo.png" block alt="Sinar Mutiara Logo"></b-img>
                <h4 class="division-date-text">{{ divisionDate }}</h4>
            </div>
            <b-row class="m-auto division-items" align-h="center">
                <b-col class="h-100 my-4 division-items-overflow" xs="12" sm="9" md="7" lg="5" xl="4">
                    <div class="w-100 division-items-item">
                        <b-row v-for="(office, index) in offices" :key="'cat-off-' + index">
                            <b-col cols="12">
                                <b-card
                                    class="card-pointer"
                                    @click="onClickOfficeButton(index)"
                                >
                                    <b-card-title class="text-center" style="font-weight:700;">
                                        {{ office.name }}
                                    </b-card-title>
                                    <b-card-body class="text-center p-0">
                                        <div style="font-size: 12px;font-weight: 620; margin-bottom:4px;">{{ office.address }}</div>
                                    </b-card-body>
                                </b-card>
                            </b-col>
                        </b-row>

                    </div>
                </b-col>
            </b-row>
        </div>
        <div v-else-if="$helper.isBlank(currDivision)" class="division-container my-auto main-body"
        style="background-image: url('katalog-bg.png');">
            <!-- <b-row class="mb-3">
                <b-col xs="12">
                    <h1 class="text-center">Pilih Kategori</h1>
                </b-col>
            </b-row> -->
            <!-- <b-row align-h="center">
                <b-col sm="6" lg="4" v-for="(division, index) in divisions" :key="'cat-div-' + index">
                    <b-card
                        :title="division.name"
                        :img-src="$BASE_FILE_PATH + division.image_path"
                        :img-alt="division.name + ' Cover Image'"
                        :bg-variant="division.variant"
                        img-top
                        class="card-pointer"
                        @click="onClickDivision(index)"
                    >
                        <b-card-text>
                            {{ division.description }}
                        </b-card-text>
                        <b-button v-if="division.variant == 'primary'" variant="light" @click="onClickDivisionButton(index)">
                            Telusuri Katalog
                        </b-button>
                    </b-card>
                </b-col>
            </b-row> -->
            <div @click="onClickHome" class="division-logo hover-pointer">
                <b-img class="division-logo-image" src="/logo.png" block alt="Sinar Mutiara Logo"></b-img>
            </div>
            <div @click="onClickHome" class="division-date hover-pointer">
                <b-img class="division-date-image" src="/logo.png" block alt="Sinar Mutiara Logo"></b-img>
                <h4 class="division-date-text">{{ divisionDate }}</h4>
            </div>
            <b-row class="vh-100 m-0 division-items" align-h="center">
                <b-col class="h-100 division-items-overflow" xs="12" sm="9" md="7" lg="5" xl="4">
                    <div class="w-100 division-items-item">
                        <b-row v-for="(division, index) in divisions" :key="'cat-div-' + index">
                            <b-col cols="12">
                                <b-card
                                    :title="division.name"
                                    class="card-pointer card-title"
                                    @click="onClickDivisionButton(index)"
                                >
                                </b-card>
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
            </b-row>
        </div>
        <b-card v-else>
            <b-row class="header-container-logo">
                <b-col cols="6" class="header-image">
                    <b-img @click="onClickHome" class="header-image-content" src="/logo.png" block alt="Sinar Mutiara Logo"></b-img>
                </b-col>
                <b-col cols="6" class="header-cart">
                    <b-button variant="danger" class="ml-2 header-cart-button" title="Logout"
                        :disabled="isSubmitting" @click="onClickLogout">
                        <i class="fa fa-fw fa-sign-out"></i>
                    </b-button>
                </b-col>
            </b-row>

            <b-row class="header-container-title">
                <b-col cols="12" class="header-title">
                    <b-button class="mr-2 header-button-back" @click="onClickBack">
                        <i class="fa fa-fw fa-chevron-left header-button-back-content" />
                    </b-button>
                    <h4 class="mb-0 header-title-text">
                        <i class="fa fa-fw fa-cubes mr-2" />Katalog Barang {{ currDivision.name }} - {{ currOffice.name }}
                    </h4>
                </b-col>
            </b-row>
            <hr />
            <b-row>
                <b-col cols="12" xs="10" sm="8" md="6" lg="5" xl="4" class="mb-3">
                    <b-input-group>
                        <b-input-group-prepend class="search-text" is-text>
                            Search
                        </b-input-group-prepend>
                        <b-input-group-prepend class="search-button-filter">
                            <b-button variant="dark" @click="$bvModal.show('m-filter')">
                                <i class="fa fa-sliders mr-2" />Filter
                            </b-button>
                        </b-input-group-prepend>
                        <b-form-input v-model="filter.name" maxlength="50" placeholder="Cari Nama Barang..." @keydown.enter="getItems()" />
                        <b-input-group-append>
                            <b-button variant="primary" @click="getItems()"><i class="fa fa-search" /></b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
            </b-row>
            <b-row class="sidebar-filter-container">
                <b-col cols="12" xs="12" sm="12" md="4" lg="3" xl="2" class="sidebar-filter">
                    <b-form class="sidebar-filter-content">
                        <strong>DATA BARANG</strong>
                        <b-form-group label="Jenis">
                            <multiselect v-model="filter.kind"
                                label="name"
                                track-by="id"
                                :internal-search="true"
                                deselect-label=""
                                select-label=""
                                :options="optKind"
                                @input="onChangeFilterKind"
                            />
                        </b-form-group>
                        <b-form-group label="Merk">
                            <multiselect v-model="filter.brand"
                                label="name"
                                track-by="id"
                                :internal-search="true"
                                deselect-label=""
                                select-label=""
                                :options="optBrand"
                                @input="onChangeFilter"
                            />
                        </b-form-group>
                        <b-form-group label="Harga Minimum">
                            <b-form-input
                                v-model="filter.minPrice"
                                maxlength="50"
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                @input="sanitizeMinPrice"
                                @blur="onChangeFilter"
                            />
                        </b-form-group>
                        <b-form-group label="Harga Maksimum">
                            <b-form-input
                                v-model="filter.maxPrice"
                                maxlength="50"
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                @input="sanitizeMaxPrice"
                                @blur="onChangeFilter"
                            />
                        </b-form-group>
                        <strong>PENILAIAN BARANG</strong>
                        <b-form-group label="Grade">
                            <multiselect :multiple="true" :close-on-select="false"
                                v-model="filter.grade"
                                label="name"
                                track-by="id"
                                :internal-search="true"
                                deselect-label=""
                                select-label=""
                                :options="optGrade"
                                @input="onChangeFilter"
                            />
                        </b-form-group>
                        <b-form-group label="Kelengkapan">
                            <b-form-select v-model="filter.isBatangan" :options="optIsBatangan" @change="getItems()" />
                        </b-form-group>
                        <b-form-group label="Spek">
                            <multiselect v-model="filter.spec"
                                label="name"
                                track-by="id"
                                :internal-search="true"
                                deselect-label=""
                                select-label=""
                                :options="optSpec"
                                @input="onChangeFilter"
                            />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="8" lg="9" xl="10" class="main-table-items">
                    <b-table bordered hover show-empty no-local-sorting
                        :busy="isBusy"
                        :items="items"
                        :fields="fields"
                        @sort-changed="onSortChanged"
                        responsive class="my-3"
                    >
                        <template v-slot:empty>
                            Tidak ada data inventory.
                        </template>
                        <template v-slot:cell(item)="row">
                            <div class="small">
                                {{ row.item.kind }} - {{ row.item.brand }}<br />
                            </div>
                            {{ row.item.type }}
                        </template>
                        <template v-slot:cell(stock)="row">
                            <!-- <strong>{{ row.item.total_items }}</strong> item -->
                            <span v-if="row.item.total_items <= 50"><strong>{{ row.item.total_items }}</strong> unit</span>
                            <span v-else>Lebih dari <strong>50</strong> unit</span>
                        </template>
                        <template v-slot:cell(price)="row">
                            <div class="small">
                                Dimulai dari harga<br />
                            </div>
                            <!-- Rp. {{ $helper.formatThousand(row.item.min_final_price) }} -->
                            <!-- Rp. {{ $helper.formatThousand(row.item.min_final_price_adj) }} -->
                            Rp. {{ $helper.formatThousand(row.item.min_final_price_segment) }}
                        </template>
                        <template v-slot:cell(action)="row">
                            <div v-if="row.item.total_items < (row.item.display_limit != null ? row.item.display_limit : 0)">
                                Hanya untuk pembelian offline
                            </div>
                            <b-button v-else size="sm" variant="dark" v-b-tooltip.hover.top title="Daftar Item" :disabled="isSubmitting" @click="onClickCatalogDetail(row.item.type_id, row.item.type)">
                                <i class="fa fa-fw fa-bars" />
                            </b-button>
                        </template>
                    </b-table>
                    <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" @page-change="onPageChange" />
                </b-col>
            </b-row>
        </b-card>
        <b-modal id="m-login" :title="account.modalTitle" no-close-on-backdrop no-close-on-esc hide-footer centered>
            <b-form>
            <b-row class="mt-1" v-if="account.type == 'login'">
                <b-col cols="12">
                    <b-form-group>
                        <b-form-input v-model="account.phone" size="lg" placeholder="Nomor Telepon" maxlength="50" />
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group class="mb-1">
                        <b-form-input type="password" v-model="account.pword" size="lg" placeholder="Password" maxlength="50" />
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-link href="#" @click="onClickReset">Reset Password</b-link>
                </b-col>
                <b-col cols="6" style="text-align:right">
                    <b-link href="#" @click="onClickRegister">Belum punya akun? Daftar disini</b-link>
                </b-col>
            </b-row>
            <b-row class="mt-1" v-else>
                <transition name="fade">
                    <div v-if="isSuccessRegister" id="register-account-success" class="card-success">
                        <i class="fa fa-check mr-2" aria-hidden="true"></i>
                    <div class="ml-2">Berhasil membuat akun</div>
                </div>
                </transition>
                <b-col cols="12">
                    <b-form-group>
                        <b-form-input v-model="account.name" size="lg" placeholder="Nama Pengguna" maxlength="50"
                            :state="nameState" />
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group>
                        <b-form-input v-model="account.email" size="lg" placeholder="Email" maxlength="50"
                            :state="emailState"/>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group>
                        <b-form-input v-model="account.store" size="lg" placeholder="Nama Toko" maxlength="50"
                            :state="storeState"/>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group>
                        <b-form-input v-model="account.addr" size="lg" placeholder="Alamat Toko" maxlength="50"
                            :state="addrState"/>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group>
                        <b-form-input v-model="account.phone" size="lg" placeholder="Nomor Telepon" maxlength="50"
                            onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode == 13"
                            :state="phoneState"/>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group>
                        <multiselect :class="{test: province != null}" class="reg-multiselect" v-model="province" placeholder="Provinsi" :options="optProvince" label="name" @close="getCity"></multiselect>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group>
                        <multiselect :class="{test: account.city != null}" class="reg-multiselect" v-model="account.city" placeholder="Kota" :options="optCity" label="name" :disabled="disableCity"
                        :state="cityState"></multiselect>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group>
                        <b-form-input type="password" v-model="account.pword" size="lg" placeholder="Password" maxlength="50"
                            :state="pwordState"/>
                    </b-form-group>
                </b-col>
                <b-col cols="12" style="text-align:right">
                    <b-form-group class="mb-1">
                        <b-form-input type="password" v-model="account.pwordCheck" size="lg" placeholder="Ulangi Password" maxlength="50"
                            :state="pwordCheckState"/>
                    </b-form-group>
                    <b-link href="#" @click="onClickLogin">Punya akun? Masuk disini</b-link>
                </b-col>
            </b-row>
            <hr />
            <div class="mt-4 text-right">
                <b-button v-if="account.type == 'login'" type="submit" variant="primary" :disabled="!isReadyLogin || isSubmitting" class="w-100" @click="onSubmitLogin">
                    {{ isSubmitting ? 'Memroses...' : 'Masuk' }}
                </b-button>
                <b-button v-else variant="primary" type="submit" :disabled="!isReadyRegister || isSubmitting" class="w-100" @click="onSubmitRegister">
                    {{ isSubmitting ? 'Memroses...' : 'Daftar dan Masuk' }}
                </b-button>
            </div>
            </b-form>
        </b-modal>

        <b-modal id="m-reset" title="Request Reset Password" no-close-on-backdrop no-close-on-esc hide-footer centered>
            <b-form v-if="resetAccount.type == 'reset'">
                <b-row class="mt-1">
                    <b-col cols="12">
                        <b-form-group>
                            <b-form-input v-model="resetAccount.phone" size="lg" placeholder="Nomor Telepon" maxlength="50"
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode == 13"
                                :state="resPhoneState"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <b-form-group>
                            <b-form-input v-model="resetAccount.email" size="lg" placeholder="Email" maxlength="50"
                                :state="resEmailState"/>
                        </b-form-group>
                    </b-col>
                </b-row>
                <hr />
                <div class="mt-4 text-right">
                    <b-button type="submit" variant="primary" :disabled="!isReadyReset || isSubmitting" class="w-100" @click="onSubmitReset">
                        {{ isSubmitting ? 'Memroses...' : 'Submit Request' }}
                    </b-button>
                </div>
            </b-form>
            <b-form v-else>
                <b-row class="mt-1">
                    <b-col cols="12">
                        <b-form-group>
                            <b-form-input type="password" v-model="resetAccount.password" size="lg" placeholder="Password" maxlength="50"
                                :state="resPasswordState"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <b-form-group>
                            <b-form-input type="password" v-model="resetAccount.passwordCheck" size="lg" placeholder="Ulangi Password" maxlength="50"
                                :state="resPasswordCheckState"/>
                        </b-form-group>
                    </b-col>
                </b-row>
                <hr />
                <div class="mt-4 text-right">
                    <b-button type="submit" variant="primary" :disabled="!isReadyChange || isSubmitting" class="w-100" @click="onSubmitChange">
                        {{ isSubmitting ? 'Memroses...' : 'Ganti Password' }}
                    </b-button>
                </div>
            </b-form>
        </b-modal>

        <b-modal id="m-filter" title="Filter Pencarian" size="lg" no-close-on-backdrop no-close-on-esc hide-footer>
            <strong>DATA BARANG</strong>
            <b-row class="mt-1">
                <b-col md="4">
                    <b-form-group label="Nama Barang">
                        <b-form-input v-model="filter.name" maxlength="50" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Jenis">
                        <multiselect v-model="filter.kind"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optKind"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Merk">
                        <multiselect v-model="filter.brand"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optBrand"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mt-1">
                <b-col md="4">
                    <b-form-group label="Harga Minimum">
                        <b-form-input
                            v-model="filter.minPrice"
                            maxlength="50"
                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                            @input="sanitizeMinPrice"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Harga Maksimum">
                        <b-form-input
                            v-model="filter.maxPrice"
                            maxlength="50"
                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                            @input="sanitizeMaxPrice"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <strong>PENILAIAN BARANG</strong>
            <b-row class="mt-1">
                <b-col md="4">
                    <b-form-group label="Grade">
                        <multiselect :multiple="true" :close-on-select="false"
                            v-model="filter.grade"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optGrade"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Kelengkapan">
                        <b-form-select v-model="filter.isBatangan" :options="optIsBatangan" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Spek">
                        <multiselect v-model="filter.spec"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optSpec"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <hr />
            <div class="mt-4 text-right">
                <b-button variant="danger" @click="resetFilter">
                    Reset Filter
                </b-button>
                <b-button variant="primary" class="ml-3" @click="getItems()">
                    Cari
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-cart" title="Keranjang" size="xl" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-row class="modal-small mb-2">
                <b-col cols="12" class="modal-table">
                    <b-table bordered hover show-empty
                        :busy="isBusy"
                        :items="cartList"
                        :fields="fieldlistCart"
                        :per-page="perPage2"
                        :filter="filter2"
                        @filtered="currentPage2=1"
                        :sort-by.sync="sortBy2"
                        :sort-desc.sync="sortDesc2"
                        @sort-changed="onSortChanged2"
                        responsive class="my-3">

                        <template v-slot:cell(merk)="row">
                            <span>{{ row.item.brands }}</span>
                        </template>
                        <template v-slot:cell(jenis)="row">
                            <span>{{ row.item.types }}</span>
                        </template>
                        <template v-slot:cell(kode)="row">
                            <strong>{{ row.item.no_faktur_pgi }}{{ row.item.append_faktur > 9 ? row.item.append_faktur.toString().substr(1,1) : row.item.append_faktur }}</strong>
                        </template>
                        <template v-slot:cell(harga)="row">
                            Rp. {{ $helper.formatThousand(row.item.final_price_after_segment) }}
                        </template>
                        <template v-slot:cell(grade)="row">
                            <strong>{{ row.item.grade }}</strong>
                        </template>
                        <template v-slot:cell(detail)="row">
                            {{ row.item.is_batangan == true ? "Batangan" : "Lengkap" }} - {{ row.item.specs }}<br />
                            <div class="small">
                                <span v-if="row.item.item_year != null">Tahun {{ row.item.item_year }}</span>
                            </div>
                        </template>
                        <template v-slot:cell(kerusakan)="row">
                            <div v-if="row.item.kerusakan != null">
                                <span>{{row.item.kerusakan}}</span>
                            </div>
                            <span v-else>-</span>
                        </template>

                        <template v-slot:cell(action)="row">
                            <b-button size="sm" variant="danger" class="ml-2" v-b-tooltip.hover.top title="Hapus dari keranjang"
                                :disabled="isSubmitting" @click="removeItemFromCart(row.item)">
                                <i class="fa fa-fw fa-minus" />
                            </b-button>
                        </template>
                    </b-table>
                </b-col>
            </b-row>
            <PageSizer :totalRows="totalRows2" :page="currentPage2" :options="options" @limit-change="onLimitChange2" @page-change="onPageChange2" />

            <div class="mt-4 text-right">
                <b-button variant="primary" class="mr-2" :disabled="isSubmitting || cartList.length == 0" @click="calculateShoppingCart">
                    Kirim
                </b-button>
                <b-button variant="secondary" class="mr-2" @click="$bvModal.hide('m-cart')">
                    Tutup
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-calculate" title="Total Order" no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="isSubmitting">
                Mengambil data, mohon menunggu...
            </div>
            <div v-else>
                Qty : {{ countShoppingCart }}<br />
                Harga : Rp. {{ totalShoppingCart }}
                <div class="mt-4 text-right">
                    <b-button variant="primary" class="mr-2" :disabled="isSubmitting" @click="sendShoppingCart">
                        Order
                    </b-button>
                    <b-button variant="secondary" class="mr-2" @click="$bvModal.hide('m-calculate')">
                        Cancel
                    </b-button>
                </div>
            </div>
        </b-modal>
        <b-modal id="m-requested" title="Request Order" no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="isSubmitting">
                Mengambil data, mohon menunggu...
            </div>
            <div v-else>
                <div v-for="(admin, index) in adminDivisions" :key="'phone-' + index" style="text-align: center">
                    <b-button class="mt-2" v-if="admin.admin_phone != null" @click="sendMessageAdmin(admin.admin_phone)" style="background-color: #25D366; border-color: #25D366; color: #fff;">
                        <i class="fa fa-whatsapp mr-1"></i>Order
                    </b-button>
                </div>
            </div>
        </b-modal>
        <FloatingButton v-if="$helper.isBlank(currOffice) || $helper.isBlank(currDivision)" :phone-number="phoneNumberResellerGeneral" />
    </div>
</template>

<script>
import lodash from 'lodash'
import moment from 'moment'
import FloatingButton from '../globals/FloatingButton.vue'

export default {
    components: {
        FloatingButton
    },
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            activeId: 0,

            filter: {
                name: "",
                kind: null,
                brand: null,
                minPrice: "",
                maxPrice: "",
                spec: null,
                grade: [],
                isBatangan: -1,
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "item", label: "Barang", sortable: true },
                { key: "stock", label: "Stok", sortable: true, thClass: "th-min-width"},
                { key: "price", label: "Harga Jual", sortable: true },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            activeItem: {},
            isSuccessRegister: false,
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            optKind: [],
            optBrand: [],

            currDivision: null,
            currOffice: null,
            currIndex: null,
            divisions: [],
            offices: [],

            divisionDate: "",

            account: {
                modalTitle: "Login Akun",
                type: 'login',
                name: "",
                email: "",
                store: "",
                addr: "",
                phone: "",
                pword: "",
                pwordCheck: "",
                city: null
            },

            optSpec: [],

            optGrade: [
                { id: "S", name: "S" },
                { id: "A", name: "A" },
                { id: "B", name: "B" },
                { id: "C", name: "C" },
                { id: "X", name: "X" },
            ],
            optIsBatangan: [
                { value: -1, text: "Semua" },
                { value: 1, text: "Batangan" },
                { value: 0, text: "Lengkap" }
            ],

            resetAccount: {
                id: "",
                type: 'reset',
                phone: "",
                email: "",
                password: "",
                passwordCheck: ""
            },

            fieldlistCart: [
                { key: "merk", label: "Merk Barang", sortable: false },
                { key: "jenis", label: "Jenis Barang", sortable: false },
                { key: "kode", label: "Kode Barang", sortable: false },
                { key: "harga", label: "Harga Jual", sortable: false },
                { key: "grade", label: "Grade", sortable: false },
                { key: "detail", label: "Detail", sortable: false },
                { key: "kerusakan", label: "Kerusakan", sortable: false },
                { key: "action", label: "Aksi" },
            ],
            cartList: [],
            perPage2: 10,
            currentPage2: 1,
            sortBy2: null,
            sortDesc2: false,
            filter2: null,
            totalRows2: 0,

            countShoppingCart: 0,
            totalShoppingCart: 0,

            noRequest: "",
            adminDivisions: [],

            optProvince: [],
            province: null,
            optCity: [],
            disableCity: true,
            phoneNumberReselerPriotity: null,
            phoneNumberResellerGeneral: null,
            tokopediaUrl: "",
        }
    },

    watch: {

        "filter.kind": function(newVal) {

            this.filter.brand = null
            this.optBrand = []

            if(newVal != null) {

                this.$axios.get("catalog/brands/" + this.filter.kind.id).then(res => {
                    this.optBrand = res.data.data
                })

            }

        }

    },

    methods: {

        init() {

            this.initStatus = 0

            let getItems = this.getItems()

            let getKinds = this.$axios.get("catalog/kinds").then(res => {
                this.optKind = res.data.data
            })

            let getSpecs = this.$axios.get("catalog/spec").then(res => {
                this.optSpec = res.data.data
            })

            Promise.all([getItems, getKinds, getSpecs]).then(_ => {
                this.initStatus = 1
            })
            .catch(_ => this.initStatus = -1)

        },

        getItems(page = 1) {

            this.$bvModal.hide("m-filter")
            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)
            param += this.processFilter()

            if(!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }

            let url = "catalog"

            if(!this.$helper.isBlank(this.currDivision)){
                url = "catalog-by-division"
                param += "&catalog_division_id=" + this.currDivision.id
            }

            if(!this.$helper.isBlank(this.currOffice)){
                param += "&officeId=" + this.currOffice.id
            }

            sessionStorage.setItem("listKatalogPage", this.currentPage)

            return this.$axios.get(url + param).then(res => {
                this.items = res.data.data.items
                this.totalRows = res.data.data.total
                sessionStorage.setItem("listKatalogFilter", JSON.stringify(this.filter))
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            sessionStorage.setItem("listKatalogPage", this.currentPage)
            this.getItems(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        resetFilter() {

            this.filter = {
                name: "",
                kind: null,
                brand: null,
                minPrice: "",
                maxPrice: "",
                spec: null,
                grade: [],
                isBatangan: -1
            }

            this.getItems()

        },

        processFilter() {

            let param = ""

            if(!this.$helper.isBlank(this.filter.name)) {
                param += "&filterName=" + this.filter.name
            }

            if(this.filter.kind != null) {
                param += "&filterKind=" + this.filter.kind.id
            }

            if(this.filter.brand != null) {
                param += "&filterBrand=" + this.filter.brand.id
            }

            let minPrice = this.$helper.toNumber(this.filter.minPrice)

            if(!this.$helper.isBlank(minPrice) && minPrice != 0) {
                param += "&filterMinPrice=" + minPrice
            }

            let maxPrice = this.$helper.toNumber(this.filter.maxPrice)

            if(!this.$helper.isBlank(maxPrice) && maxPrice != 0) {
                param += "&filterMaxPrice=" + maxPrice
            }
            if(this.filter.grade.length != 0) {
                param += "&filterGrade=" + this.filter.grade.map(it => it.id).join()
            }

            if(this.filter.isBatangan != -1) {
                param += "&filterIsBatangan=" + this.filter.isBatangan
            }

            if(this.filter.spec != null) {
                param += "&filterSpec=" + this.filter.spec.id
            }

            return param

        },

        onClickCatalogDetail(id, type){
            // this.$store.commit('set', ['typeKatalogId', id])
            // this.$store.commit('set', ['typeKatalogDetail', type])
            // this.$router.push({ path: 'katalog/detail' })
            this.$router.push({ path: 'katalog/' + id, query: {
                minPrice: this.filter.minPrice ? this.$helper.toNumber(this.filter.minPrice) : 0,
                maxPrice: this.filter.maxPrice ? this.$helper.toNumber(this.filter.maxPrice) : 0,
                grade: this.filter.grade.length > 0 ? this.filter.grade.map(it => it.id).join() : "",
                isBatangan: this.filter.isBatangan && this.filter.isBatangan != 0 ? this.filter.isBatangan : -1,
                spec: this.filter.spec ? this.filter.spec.id+","+this.filter.spec.name : ""
            } })
        },

        sanitizeMinPrice() {
            let cleaned = String(this.filter.minPrice).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.filter.minPrice = res
        },

        sanitizeMaxPrice() {
            let cleaned = String(this.filter.maxPrice).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.filter.maxPrice = res
        },

        onClickDivision(index){
            for(let i = 0; i < this.divisions.length; i++){
                this.divisions[i].variant = "default"
            }
            this.divisions[index].variant = "primary"
        },
        onClickOfficeButton(index){
            this.currOffice = lodash.cloneDeep(this.offices[index])
            sessionStorage.setItem("listKatalogOffice", JSON.stringify(this.currOffice))
        },
        onClickDivisionButton(index){

            if(!this.$helper.isBlank(localStorage.getItem("token-katalog")) && !this.$helper.isBlank(localStorage.getItem("loginTime-katalog"))){
                this.initStatus = 0
                this.currDivision = lodash.cloneDeep(this.divisions[index])
                sessionStorage.setItem("listKatalogDivision", JSON.stringify(this.currDivision))

                let getItems = this.getItems()

                let getKinds = this.$axios.get("catalog/kinds-by-division?catalog_division_id=" + this.currDivision.id).then(res => {
                    this.optKind = res.data.data
                })

                let getSpecs = this.$axios.get("catalog/spec").then(res => {
                    this.optSpec = res.data.data
                })

                Promise.all([getItems, getKinds, getSpecs]).then(_ => {
                    this.initStatus = 1
                })
                .catch(_ => this.initStatus = -1)
            }
            else {
                this.currIndex = index
                this.$bvModal.show("m-login")
            }

        },
        onClickBack(){
            this.currDivision = null
            sessionStorage.removeItem("listKatalogDivision")
        },

        onClickHome(){
            this.currOffice = null
            sessionStorage.removeItem("listKatalogOffice")
            this.currDivision = null
            sessionStorage.removeItem("listKatalogDivision")
        },

        onClickRegister(){
            this.account = {
                modalTitle: "Daftar Akun Baru",
                type: 'register',
                name: "",
                email: "",
                store: "",
                addr: "",
                phone: "",
                pword: "",
                pwordCheck: ""
            }
        },
        onClickLogin(){
            this.account = {
                modalTitle: "Login Akun",
                type: 'login',
                name: "",
                email: "",
                store: "",
                addr: "",
                phone: "",
                pword: "",
                pwordCheck: ""
            }
        },
        onSubmitLogin(event){
            event.preventDefault()
            this.isSubmitting = true

            let payload = new FormData()
            payload.append("handphone", this.account.phone)
            payload.append("password", this.account.pword)

            this.$axios.post(`auth/login-catalog`, payload).then(response => {

                let data = response.data.data

                let currentVersion = localStorage.getItem("version-katalog")
                if(currentVersion === null || currentVersion !== data.version) {
                    localStorage.setItem("reload-katalog", 1)
                    localStorage.setItem("version-katalog", data.version)
                }

                localStorage.setItem("token-katalog", "Bearer " + data.token)
                localStorage.setItem("name-katalog", data.name)
                localStorage.setItem("shopName-katalog", data.shopName)
                localStorage.setItem("loginTime-katalog", data.loginTime)
                localStorage.setItem("customerId-katalog", data.customerId)

                this.$axios.defaults.headers.common['Authorization'] = localStorage.getItem('token-katalog')
                this.$axios.defaults.headers.common['LoginTime'] = localStorage.getItem('loginTime-katalog')

                this.$bvModal.hide('m-login')

                this.initStatus = 0
                this.currDivision = lodash.cloneDeep(this.divisions[this.currIndex])
                sessionStorage.setItem("listKatalogDivision", JSON.stringify(this.currDivision))

                let getItems = this.getItems()

                let getKinds = this.$axios.get("catalog/kinds-by-division?catalog_division_id=" + this.currDivision.id).then(res => {
                    this.optKind = res.data.data
                })

                let getSpecs = this.$axios.get("catalog/spec").then(res => {
                    this.optSpec = res.data.data
                })

                Promise.all([getItems, getKinds, getSpecs]).then(_ => {
                    this.initStatus = 1
                })
                .catch(_ => this.initStatus = -1)

            })
            .catch(error => {
                this.$helper.toastError(this, error.response.data.error)
            })
            .finally(() => {
                this.isSuccessRegister = false
                this.isSubmitting = false
            })

        },
        onSubmitRegister(event){
            event.preventDefault()
            this.isSubmitting = true

            let payload = new FormData()
            payload.append("name", this.account.name)
            payload.append("shopName", this.account.store)
            payload.append("email", this.account.email)
            payload.append("handphone", this.account.phone)
            payload.append("address", this.account.addr)
            payload.append("password", this.account.pword)
            payload.append("cityId", this.account.city.id)

            this.$axios.post(`/catalog/register-customer`, payload).then(response => {

                this.isSuccessRegister = true
                setTimeout(() => {
                    this.onSubmitLogin(event)
                }, 1000)
            })
            .catch(error => {
                this.$helper.toastError(this, error.response.data.error)
                this.isSubmitting = false
            })
        },
        onClickReset(){
            this.$bvModal.hide("m-login")
            this.$bvModal.show("m-reset")
        },
        onSubmitReset(){
            this.isSubmitting = true

            let payload = new FormData()
            payload.append("handphone", this.resetAccount.phone)
            payload.append("email", this.resetAccount.email)

            this.$axios.post(`/catalog/request-reset-password`, payload).then(response => {
                this.resetAccount = {
                    id: response.data.data.id,
                    type: 'change',
                    phone: "",
                    email: "",
                    password: "",
                    passwordCheck: ""
                }

                this.$helper.toastSuccess(this, "Request reset password diterima!")
            })
            .catch(error => {
                this.$helper.toastError(this, error.response.data.error)
            }).finally(() => {
                this.isSubmitting = false
            })
        },
        onSubmitChange(){
            this.isSubmitting = true

            let payload = new FormData()
            payload.append("id", this.resetAccount.id)
            payload.append("password", this.resetAccount.password)

            this.$axios.post(`/catalog/change-password`, payload).then(response=> {
                this.resetAccount = {
                    id: "",
                    type: 'reset',
                    phone: "",
                    email: "",
                    password: "",
                    passwordCheck: ""
                }

                this.$helper.toastSuccess(this, "Password berhasil diubah!")
                this.$bvModal.hide("m-reset")
            })
            .catch(error => {
                this.$helper.toastError(this, error.response.data.error)
            }).finally(() => {
                this.isSubmitting = false
            })
        },
        showCart(modal){
            this.cartList = []
            this.isBusy = true
            let param = this.$helper.getBasePagedQuery(this.currentPage2, this.perPage2)
            param += "&customerId="+localStorage.getItem('customerId-katalog')

            if(!this.$helper.isBlank(this.currOffice)){
                param += "&officeId=" + this.currOffice.id
            }

            sessionStorage.setItem("shoppingCartPage", this.currentPage2)

            return this.$axios.get(`/catalog/get-shopping-cart`+param).then(response=> {
                this.cartList = response.data.data.items
                this.totalRows2 = response.data.data.total
                if(modal){
                    this.$bvModal.show("m-cart")
                }
            })
            .catch(error => {
                this.$helper.toastError(this, error.response.data.error)
            }).finally(() => {
                this.isBusy = false
            })
        },
        onSortChanged2(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.showCart(false)
        },
        onLimitChange2(newPerPage) {
            this.perPage2 = newPerPage
        },

        onPageChange2(newPage) {
            this.currentPage2 = newPage
            sessionStorage.setItem("shoppingCartPage", this.currentPage2)
            this.showCart(false)
        },
        removeItemFromCart(item){
            this.isSubmitting = true

            let payload = new FormData()
            payload.append("customerId", localStorage.getItem('customerId-katalog'))
            payload.append("inventoryId", item.id)

            if(!this.$helper.isBlank(this.currOffice)){
                payload.append("officeId", this.currOffice.id)
            }

            this.$axios.post(`/catalog/remove-item-shopping-cart`, payload).then(response => {

                this.$helper.toastSuccess(this, "Barang telah dihapus dari keranjang!")
                this.showCart(false)

            })
            .catch(error => {
                this.$helper.toastError(this, error.response.data.error)
            }).finally(() => {
                this.isSubmitting = false
            })
        },
        calculateShoppingCart(){
            this.isSubmitting = true
            this.isBusy = true

            this.$bvModal.show("m-calculate")

            let payload = new FormData()
            payload.append("customerId", localStorage.getItem('customerId-katalog'))

            if(!this.$helper.isBlank(this.currOffice)){
                payload.append("officeId", this.currOffice.id)
            }

            this.$axios.post(`/catalog/calculate-shopping-cart`, payload).then(response => {
                this.countShoppingCart = response.data.data.count
                this.totalShoppingCart = this.$helper.formatThousand(parseInt(response.data.data.total))
            })
            .catch(error => {
                this.$helper.toastError(this, error.response.data.error)
            }).finally(() => {
                this.isSubmitting = false
                this.isBusy = false
            })
        },
        sendShoppingCart(){
            this.isSubmitting = true
            this.isBusy = true

            let payload = new FormData()
            payload.append("customerId", localStorage.getItem('customerId-katalog'))

            if(!this.$helper.isBlank(this.currOffice)){
                payload.append("officeId", this.currOffice.id)
            }

            this.$axios.post(`/catalog/add-shopping-cart-request`, payload).then(response => {
                this.$bvModal.hide("m-cart")
                this.$bvModal.hide("m-calculate")

                this.noRequest = response.data.data.no_request
                this.adminDivisions = response.data.data.divisions
                this.$helper.toastSuccess(this, "Barang telah di request ke SM!")
                this.$bvModal.show("m-requested")
            })
            .catch(error => {
                this.$helper.toastError(this, error.response.data.error)
            }).finally(() => {
                this.isSubmitting = false
                this.isBusy = false
            })
        },
        sendMessageAdmin(phone){
            window.open('https://wa.me/'+phone+'/?text=Nomor Orderan : '+this.noRequest+' tolong diproses')
        },
        getCity(){
            if(this.province != null){
                this.$axios.get("/catalog/city/"+this.province.id).then(res => {
                    this.optCity = res.data.data
                })
                this.disableCity = false
            } else {
                this.account.city = null
                this.disableCity = true
            }
        },
        onChangeFilter(){
            sessionStorage.setItem("katalogDetailPage", 1)
            this.getItems()
        },
        onChangeFilterKind(){
            sessionStorage.setItem("katalogDetailPage", 1)
            this.filter.brand = null
            this.getItems()
        },
        onClickLogout(){
            let confirmed = confirm("Apakah anda yakin ingin log out? Anda akan kembali ke menu utama.")
            if(confirmed) {
                this.$axios.defaults.headers.common['Authorization'] = ""
                localStorage.clear()
                this.onClickHome()
            }
        },
        openWhatsAppChat() {
            const formattedNumber = this.phoneNumberReselerPriotity.replace(/^\+/, '');
            window.open(`https://wa.me/${formattedNumber}`, '_blank');
        }

    },
    created() {

        this.divisionDate = moment().locale("id").format("dddd, DD MMMM YYYY")

        let page = 1

        if(!this.$helper.isBlank(sessionStorage.getItem("listKatalogPage"))){
            this.currentPage = parseInt(sessionStorage.getItem("listKatalogPage"))
            page = parseInt(sessionStorage.getItem("listKatalogPage"))
        }

        if(!this.$helper.isBlank(sessionStorage.getItem("shoppingCartPage"))){
            this.currentPage2 = parseInt(sessionStorage.getItem("shoppingCartPage"))
        }

        let getMarketplaceUrl = this.$axios.get("catalog/marketplace-url").then(res => {
            this.tokopediaUrl = res.data.data.tokopedia_url
        })

        if(!this.$helper.isBlank(localStorage.getItem("token-katalog")) && !this.$helper.isBlank(localStorage.getItem("loginTime-katalog"))){
            this.$axios.defaults.headers.common['Authorization'] = localStorage.getItem('token-katalog')
            this.$axios.defaults.headers.common['LoginTime'] = localStorage.getItem('loginTime-katalog')

            if(!this.$helper.isBlank(sessionStorage.getItem("listKatalogFilter"))){
                this.filter = JSON.parse(sessionStorage.getItem("listKatalogFilter"))
            }
            if(!this.$helper.isBlank(sessionStorage.getItem("listKatalogOffice"))){
                this.currOffice = JSON.parse(sessionStorage.getItem("listKatalogOffice"))
            }
            if(!this.$helper.isBlank(sessionStorage.getItem("listKatalogDivision"))){
                this.currDivision = JSON.parse(sessionStorage.getItem("listKatalogDivision"))

                let getItems = this.getItems(page)

                let getKinds = this.$axios.get("catalog/kinds-by-division?catalog_division_id=" + this.currDivision.id).then(res => {
                    this.optKind = res.data.data
                })

                let getSpecs = this.$axios.get("catalog/spec").then(res => {
                    this.optSpec = res.data.data
                })

                let getCatalogDivision = this.$axios.get("catalog/divisions").then(res => {
                    this.divisions = res.data.data.catalog_divisions.map(item => {
                        return {
                            id: item.id,
                            name: item.name,
                            image_path: item.image_path,
                            description: item.description,
                            variant: "default",
                            division_id: item.division_id,
                            min_order_quantity: item.min_order_quantity,
                        }
                    });

                })

                let getOffices = this.$axios.get("catalog/office").then(res => {
                    this.offices = res.data.data.items.map(item => {
                        return {
                            id: item.id,
                            name: item.name,
                            address: item.address,
                            phone: item.phone
                        }
                    })
                })

                Promise.all([getItems, getKinds, getCatalogDivision, getOffices, getSpecs, getMarketplaceUrl]).then(_ => {
                    this.initStatus = 1
                })
                .catch(_ => this.initStatus = -1)
            }
            else{
                this.initStatus = 0

                let getCatalogDivision = this.$axios.get("catalog/divisions").then(res => {
                    this.divisions = res.data.data.catalog_divisions.map(item => {
                        return {
                            id: item.id,
                            name: item.name,
                            image_path: item.image_path,
                            description: item.description,
                            variant: "default",
                            division_id: item.division_id,
                            min_order_quantity: item.min_order_quantity,
                        }
                    });
                })

                let getOffices = this.$axios.get("catalog/office").then(res => {
                    this.offices = res.data.data.items.map(item => {
                        return {
                            id: item.id,
                            name: item.name,
                            address: item.address,
                            phone: item.phone
                        }
                    })
                })

                let getProvinces = this.$axios.get("catalog/province").then(res => {
                    this.optProvince = res.data.data
                })

                let getPhoneNumberPriority = this.$axios.get("catalog/phone-number?id=38").then(res => {
                    this.phoneNumberReselerPriotity = res.data.data.value
                })

                let getPhoneNumberGeneral = this.$axios.get("catalog/phone-number?id=37").then(res => {
                    this.phoneNumberResellerGeneral = res.data.data.value
                })

                Promise.all([getCatalogDivision, getOffices, getProvinces, getPhoneNumberPriority, getPhoneNumberGeneral, getMarketplaceUrl]).then(_ => {
                    this.initStatus = 1
                })
                .catch(_ => this.initStatus = -1)
            }
        }
        else{
            this.initStatus = 0

            let getCatalogDivision = this.$axios.get("catalog/divisions").then(res => {
                this.divisions = res.data.data.catalog_divisions.map(item => {
                    return {
                        id: item.id,
                        name: item.name,
                        image_path: item.image_path,
                        description: item.description,
                        variant: "default",
                        min_order_quantity: item.min_order_quantity,
                    }
                });
            })

            let getOffices = this.$axios.get("catalog/office").then(res => {
                this.offices = res.data.data.items.map(item => {
                    return {
                        id: item.id,
                        name: item.name,
                        address: item.address,
                        phone: item.phone
                    }
                })
            })

            let getProvinces = this.$axios.get("catalog/province").then(res => {
                this.optProvince = res.data.data
            })

            let getPhoneNumberPriority = this.$axios.get("catalog/phone-number?id=38").then(res => {
                    this.phoneNumberReselerPriotity = res.data.data.value
                })

            let getPhoneNumberGeneral = this.$axios.get("catalog/phone-number?id=37").then(res => {
                this.phoneNumberResellerGeneral = res.data.data.value
            })

            Promise.all([getCatalogDivision, getOffices, getProvinces, getPhoneNumberPriority, getPhoneNumberGeneral]).then(_ => {
                this.initStatus = 1
            })
            .catch(_ => this.initStatus = -1)
        }

        // this.init()
    },
    computed: {
        nameState() {
            if(this.account.name.length <= 0) return null
            return this.account.name.length > 0 ? true : false
        },
        emailState() {
            if(this.account.email.length <= 0) return null
            return /^\S+@\S+\.\S+$/.test(this.account.email)
        },
        storeState() {
            if(this.account.store.length <= 0) return null
            return this.account.store.length > 0 ? true : false
        },
        addrState() {
            if(this.account.addr.length <= 0) return null
            return this.account.addr.length > 0 ? true : false
        },
        phoneState() {
            if(this.account.phone.length <= 0) return null
            return this.account.phone.length > 6 ? true : false
        },
        pwordState() {
            if(this.account.pword.length <= 0) return null
            return this.account.pword.length > 0 ? true : false
        },
        pwordCheckState() {
            if(this.account.pwordCheck.length <= 0) return null
            return this.account.pwordCheck == this.account.pword ? true : false
        },
        cityState() {
            if(this.account.city == null) return null
            return this.account.city.id != null ? true : false
        },
        isReadyRegister() {
            if(this.nameState && this.emailState && this.storeState && this.addrState && this.phoneState && this.pwordState && this.pwordCheckState && this.cityState){
                return true
            }
            else {
                return false
            }
        },
        isReadyLogin() {
            if(this.account.phone.length > 0 && this.account.pword.length > 0) {
                return true
            }
            else {
                return false
            }
        },
        resPhoneState(){
            if(this.resetAccount.phone.length <= 0) return null
            return this.resetAccount.phone.length > 6 ? true : false
        },
        resEmailState(){
            if(this.resetAccount.email.length <= 0) return null
            return /^\S+@\S+\.\S+$/.test(this.resetAccount.email)
        },
        resPasswordState(){
            if(this.resetAccount.password.length <= 0) return null
            return this.resetAccount.password.length > 0 ? true : false
        },
        resPasswordCheckState(){
            if(this.resetAccount.passwordCheck.length <= 0) return null
            return this.resetAccount.passwordCheck == this.resetAccount.password ? true : false
        },
        isReadyReset() {
            if(this.resPhoneState && this.resEmailState){
                return true
            } else {
                return false
            }
        },
        isReadyChange() {
            if(this.resPasswordState && this.resPasswordCheckState){
                return true
            } else {
                return false
            }
        },
    }
}
</script>

<style scoped>
    /deep/ .th-min-width {
        min-width: 85px;
    }
    /* /deep/ .modal-content {
        margin-right:30px;
    } */
    .main-table-items {
        margin-top: -16px;
    }
    hr {
        margin-top:15px;
    }
    .header-container-logo {
        height: 70px;
        margin-bottom: 10px;
    }
    .header-container-title {
        height: 40px;
    }
    .header-title {
        display: flex;
        align-items: center;
        height: 40px;
        overflow-y: hidden;
    }
    .header-button-back {
        float: left;
        padding: 0px;
        height: 30px;
        width: 30px;
        background-color: white;
        border: 0px;
    }
    .header-button-back-content {
        margin-top: 4px;
        font-size: 1.45rem;
    }
    .header-title-text {
        font-size: 1rem;
        font-weight: 700;
    }
    .header-image {
        text-align: center;
        height: 70px;
    }
    .header-image-content {
         height:100%;
         cursor:pointer;
    }
    .hover-pointer {
         cursor:pointer;
    }
    .header-cart {
        text-align: right;
        display: flex;
        align-items: center;
        justify-content:flex-end;
    }
    .header-cart-button {
        font-size: 0.9rem;
    }
    .header-cart-text {
        display: none;
    }
    .division-date {
        z-index: 99;
        padding: 2px;
        position: sticky;
        top:0px;
        width: 100%;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: white;
    }
    .division-date-text {
        vertical-align: middle;
        font-size: 5.3vw;
        margin-right: 2px;
        cursor: default;
        color: #062D78;
    }
    .division-date-image {
        text-align: left;
        float: left;
        width: 35%;
    }
    .division-logo {
        display: none;
    }
    .main-body {
        background-repeat:no-repeat;
        background-size:cover;
        background-position:center top;
        height: 100%;
        min-height: 100vh;
        background-attachment: fixed;
    }
    .card-title {
        font-size: 2.6rem;
        margin-bottom: 5px !important;
    }
    .division-container {
        margin: 20px;
        margin-left: 0px;
        margin-right: 0px;
    }
    .division-items-overflow {
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none;  /* Internet Explorer 10+ */
        display:flex;
        align-items:center;
    }
    .division-items-overflow::-webkit-scrollbar { /* WebKit */
        display: none;
        width: 0;
        height: 0;
    }
    .card-pointer {
        border-radius: 1rem;
        border: 5px solid #042D7F;
        color: #062D78;
    }
    .card-pointer > .card-body {
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .card-img-top {
        border-top-left-radius: 1rem;
        border-top-right-radius: 1rem;
        height: 200px;
        width: 100%;
        object-fit: cover;
    }
    .search-button-filter {
        display:block;
    }
    .search-text {
        display:none;
    }
    .sidebar-filter {
        display: none;
    }
    .media-container {
        height: 0;
        padding-top: 56.25%;
        position: relative;
    }
    .media-preview {
        max-height: 100%;
        max-width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        border: 1px solid #dee2e6;
        border-radius: .25rem;
        object-fit: cover;
        background-color: #dee2e6;
        left: 50%;
        transform: translateX(-50%);
    }
    :not(:root):-webkit-full-screen {
        object-fit: contain !important;
    }
    .media-scroll {
        margin-top: 10px;
        height: 70px;
        width: 100%;
        overflow-x: scroll;
        overflow-y: hidden;
        background-color: #dee2e6;
        white-space: nowrap;
    }
    .media-scroll-content {
        display: inline-block !important;
        height: 100%;
        width: 20%;
    }
    .media-scroll-preview.active {
        border: 5px solid #65c2e4;
    }
    .media-scroll-preview:hover {
        opacity: 0.5;
    }
    .media-scroll-preview {
        height: 100%;
        width: 100%;
        border: 5px solid #dee2e6;
        border-radius: .25rem;
        object-fit: cover;
        background-color: #dee2e6;
        cursor: pointer;
    }
    .border-responsive {
        margin-top: 10px;
        border-top: 1px solid #c8ced3;
    }
    .media-disclaimer {
        text-align: justify;
        text-justify: inter-word;
    }
    .reg-multiselect {
        font-size: 1.09375rem;
        min-height: calc(1.5em + 1rem + 2px);
    }
    .card-new-customer {
        background-color: #ffffff;
        border: 1px solid #f9fdd8;
        padding: 10px 20px;
        border-radius: 5px;
        margin-top: 10px;
    }
    .card-new-customer-text {
        font-size: 1.2rem;
        font-weight: 500;
    }

    .card-description-category {
        font-size: 1rem;
    }

    .card-success {
        background-color: #a6ffd2;
        border: 1px solid #4dbd74;
        padding: 10px 20px;
        border-radius: 5px;
        margin-top: 10px;
        width: 100%;
        display: flex;
        justify-content: center;
        margin: 15px;
        align-items: center;
        color: #006b46;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.5s ease;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }


    /deep/ .test > .multiselect__tags {
        border: 1px solid #4dbd74;
    }
    @media only screen and (min-width: 576px) {
        hr {
            margin-top:4px;
        }
        .header-cart-text {
            display: inline;
        }
        .media-scroll {
            height: 100px;
        }
        .division-date {
            padding-left: 10px;
            padding-right: 10px;
        }
        .division-date-text {
            font-size: 1.8rem;
        }
        .division-date-image {
            height: 100%;
            width: auto;
        }
    }
    @media only screen and (min-width: 768px) {
        .search-button-filter {
            display:none;
        }
        .search-text {
            display:block;
        }
        .sidebar-filter-container {
            padding-top: 15px;
            padding-left: 15px;
        }
        .sidebar-filter {
            border: 1px solid #c8ced3;
            display: block;
            background-color: #f0f3f5;
            border-radius: 0.25rem;
        }
        .sidebar-filter-content {
            padding-top: 15px;
        }
        .division-logo {
            display: block;
            border-bottom-right-radius: 1rem;
            position: absolute;
            top:0px;
            left:0px;
            width: 208px;
            height: 80px;
            background-color: white;
            padding: 12px 8px 12px 8px;
        }
        .division-logo-image {
            height: 100%;
        }
        .division-date {
            border-bottom-left-radius: 1rem;
            position: absolute;
            top:0px;
            right:0px;
            width: 350px;
            height: 80px;
            background-color: white;
            justify-content: flex-end;
        }
        .division-date-text {
            font-size: 1.8rem;
        }
        .division-date-image {
            display: none !important;
        }
        .division-items-overflow {
            padding-top: 80px;
        }
    }
    @media only screen and (min-width: 992px) {
        .border-responsive {
            margin-top: 0px;
            border-top: none;
            border-left: 1px solid #c8ced3;
        }
        .division-logo {
            border-bottom-right-radius: 1rem;
            width: 208px;
            height: 80px;
            padding: 12px 8px 12px 8px;
        }
        .division-logo-image {
            height: 100%;
        }
        .division-date {
            width: 300px;
            height: 60px;
        }
        .division-date-text {
            font-size: 1.6rem;
        }
        .division-items-overflow {
            padding-top: 0px;
        }
    }
    @media only screen and (min-width: 1200px) {
        .media-scroll {
            height: 150px;
        }
        .division-logo {
            width: 208px;
            height: 80px;
            padding: 8px 8px 12px 8px;
        }
        .division-date {
            width: 350px;
            height: 70px;
        }
        .division-date-text {
            font-size: 1.8rem;
        }
    }

    .custom-button {
        display: flex;
        align-items: center;
    }

    @media (max-width: 768px) {
        .card-title {
            font-size: 25px !important;
        }

        .card-description {
            font-size: 14px !important;
        }
    }

    .notification-banner {
        margin-bottom: 10px;
        padding: 10px 20px;
        width: 100%;
        border: 1px solid #FFD93D;
        background-color: #FDEB9F;
        text-align: center;
        font-weight: 600;
        color: #856404;
        font-size: 14px;
    }

</style>
